var _circle, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.75 33.7778V46.5333C52.75 49.1469 52.75 50.4537 52.2595 51.452C51.8281 52.33 51.1397 53.044 50.293 53.4914C49.3304 54 48.0702 54 45.55 54H34.45C31.9298 54 30.6696 54 29.707 53.4914C28.8603 53.044 28.1719 52.33 27.7405 51.452C27.25 50.4537 27.25 49.1469 27.25 46.5333V33.7778M27.4 26H52.6C53.4401 26 53.8601 26 54.181 26.1695C54.4632 26.3187 54.6927 26.5567 54.8365 26.8493C55 27.1821 55 27.6177 55 28.4889V31.2889C55 32.1601 55 32.5957 54.8365 32.9284C54.6927 33.2211 54.4632 33.4591 54.181 33.6082C53.8601 33.7778 53.4401 33.7778 52.6 33.7778H27.4C26.5599 33.7778 26.1399 33.7778 25.819 33.6082C25.5368 33.4591 25.3073 33.2211 25.1635 32.9284C25 32.5957 25 32.1601 25 31.2889V28.4889C25 27.6177 25 27.1821 25.1635 26.8493C25.3073 26.5567 25.5368 26.3187 25.819 26.1695C26.1399 26 26.5599 26 27.4 26ZM36.4 39.2222H43.6C44.4401 39.2222 44.8601 39.2222 45.181 39.3918C45.4632 39.5409 45.6927 39.7789 45.8365 40.0716C46 40.4043 46 40.8399 46 41.7111V42.9556C46 43.8267 46 44.2623 45.8365 44.5951C45.6927 44.8878 45.4632 45.1258 45.181 45.2749C44.8601 45.4444 44.4401 45.4444 43.6 45.4444H36.4C35.5599 45.4444 35.1399 45.4444 34.819 45.2749C34.5368 45.1258 34.3073 44.8878 34.1635 44.5951C34 44.2623 34 43.8267 34 42.9556V41.7111C34 40.8399 34 40.4043 34.1635 40.0716C34.3073 39.7789 34.5368 39.5409 34.819 39.3918C35.1399 39.2222 35.5599 39.2222 36.4 39.2222Z",
    stroke: "#ABB1BB",
    strokeWidth: 3.27272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6 39.2158H36.4C35.5599 39.2158 35.1399 39.2158 34.819 39.3851C34.5368 39.5341 34.3073 39.7717 34.1635 40.064C34 40.3963 34 40.8313 34 41.7014V42.9441C34 43.8142 34 44.2492 34.1635 44.5815C34.3073 44.8738 34.5368 45.1114 34.819 45.2604C35.1399 45.4297 35.5599 45.4297 36.4 45.4297H43.6C44.4401 45.4297 44.8601 45.4297 45.181 45.2604C45.4632 45.1114 45.6927 44.8738 45.8365 44.5815C46 44.2492 46 43.8142 46 42.9441V41.7014C46 40.8313 46 40.3963 45.8365 40.064C45.6927 39.7717 45.4632 39.5341 45.181 39.3851C44.8601 39.2158 44.4401 39.2158 43.6 39.2158Z",
    stroke: "#ABB1BB",
    strokeWidth: 3.27272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_513_45781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4163 45.583L44.583 56.4163M44.583 45.583L55.4163 56.4163",
    stroke: "#586479",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_513_45781",
    x: 36,
    y: 37,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_513_45781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_513_45781",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/EmptyBox.d1b059f673780bd3bf20b54e2c6dbf48.svg";
export { ForwardRef as ReactComponent };